export const convertToTime = (start: string, end: string): string => {
    if (!start || !end) {
        return 'N/A';
    }
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diff = endDate.getTime() - startDate.getTime();
    if (diff < 0) {
        return 'N/A';
    }
    const hundredths = Math.floor(diff / 100) % 10;
    const seconds = Math.floor(diff / 1000) % 60;
    const minutes = Math.floor(diff / (1000 * 60)) % 60;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    if (hours === 0 && minutes === 0 && seconds === 0) {
        return `0.${hundredths}s`;
    }
    if (hours === 0 && minutes === 0) {
        return `${seconds}.${hundredths}s`;
    }
    if (hours === 0) {
        return `${minutes}m ${seconds}s`;
    }
    return `${hours}h ${minutes}m ${seconds}s`;
}